<div class="d-flex justify-content-center">
  <div class="col-md-12 withpadding">
    <span class="table-title">Parameter Values</span>
  </div>
</div>

<!-- TODO Create parameter value component (based on edit-param-value-component) -->

<!-- View and edit parametervalues in table -->
<app-parameter-values-table></app-parameter-values-table>